import React, { useEffect } from 'react'
import Footer from '../core/Footer'
import { Navbar } from '../core/Navbar'
import { Content } from '../sections/service/Content'

export const Services = () => {
    useEffect(() => {
        document.title = "Services - Four Fox Security Pvt. Ltd.";
    }, []);

    return (
        <div>
            <Navbar />
            <Content />
            <Footer />
        </div>
    )
}
